<template>
  <Navagation/>
  <div>
    <div class="row">
      <a class="waves-effect waves-light btn" href="./create"><i class="material-icons left">add_circle_outline</i>Create</a>
    </div>
    <div class="row">
      <a class="waves-effect waves-light btn" href="./list"><i class="material-icons left">view_list</i>List</a>
    </div>
    <div class="row">
      <a class="waves-effect waves-light btn" href="./query"><i class="material-icons left">view_list</i>Query</a>
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import Navagation from '@/components/Navagation.vue'

export default {
  name: 'App',
  components: {
    Navagation
  },
  data() {
            return {
                authenticated: false,
            }
          },
  mounted () {
    M.AutoInit()
  },
  methods:{
    setAuthenticated(status) {
                this.authenticated = status;
            }

  }

}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>